var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }